import React from "react";
import { SiInstagram } from "react-icons/si";
import { FaTiktok } from "react-icons/fa";
import { FaSnapchatGhost } from "react-icons/fa";
import { socialType } from "../utils/Enums";

export const SocailIcon: React.FC<{ socailType: socialType }> = (props) => {
  const { socailType } = props;
  const getIcon = () => {
    switch (socailType) {
      case socialType.instagram:
        return <SiInstagram size={".8rem"} />;
      case socialType.snapChat:
        return <FaSnapchatGhost size={".8rem"} />;
      case socialType.tiktok:
        return <FaTiktok size={".8rem"} />;
    }
  };
  return (
    <div className="icon">
      <a href="#about">{getIcon()}</a>
    </div>
  );
};
